import { number, string, z } from 'zod';

export const normalizedErrorMessageSchema = z.object({
  message: z.string(),
  normalizedMessage: z.string(),
  path: z.array(string().or(number())).nullable().optional(),
});

export const normalizedMessageSchema = z.object({
  messages: z.array(normalizedErrorMessageSchema),
});

export type NormalizedMessage = z.infer<typeof normalizedErrorMessageSchema>;

export class NormalizedError extends Error {
  public readonly messages: NormalizedMessage[];

  constructor(messages: NormalizedMessage[]) {
    super('Normalized Error');
    this.messages = messages;
  }
}

export const httpErrorSchema = z.object({
  message: z.string(),
  statusCode: z.number(),
  error: z.string(),
});

export class HttpError extends Error {
  statusCode: number;
  details?: string;

  constructor(message: string, statusCode: number, details?: string) {
    super(message);
    this.name = 'HttpError';
    this.statusCode = statusCode;
    this.details = details;
  }
}
